import React, { useId } from "react";
import "./AuthInput.css";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CheckInvoiceNoAvailabliltyAPI } from "../../ApiRequests";
import { FiMail } from "react-icons/fi";

const AuthInput = ({
  Type,
  label,
  placeholder,
  required,
  Value,
  setValue,
  readonly,
  disabled,
  Named,
  Width,
  uppercaseAllowed,
  autoComplete,
  autoFocus,
  labelLayout = "floating",
  variant = "default",
  icon,
}) => {
  const inputId = useId();
  const isStacked = labelLayout === "stacked";
  const isAuth = variant === "auth";

  const labelClass = isAuth
    ? "text-sm font-semibold text-ink"
    : isStacked
      ? "text-[11px] font-bold uppercase tracking-wider text-main"
      : "absolute top-[-9px] left-3 w-fit max-w-[85%] truncate bg-card px-1 h-[16px] text-sm font-bold InputLabel text-main rounded";

  const inputClass = isAuth
    ? "pl-10 pr-3 py-2.5 h-11 border border-line bg-field text-ink placeholder:text-muted rounded-xl w-full outline-none transition-all duration-150 focus:border-main focus:ring-2 focus:ring-main/15 shadow-soft disabled:bg-subtle disabled:text-muted disabled:cursor-not-allowed"
    : "px-3 py-2.5 border border-line bg-field text-ink placeholder:text-muted rounded-xl w-full outline-none InputText transition-all duration-150 focus:border-main focus:ring-2 focus:ring-main/15 shadow-soft disabled:bg-subtle disabled:text-muted disabled:cursor-not-allowed";

  return (
    <div
      className={`${isStacked ? "flex flex-col gap-1.5" : "relative"} mb-4 ${
        Width ? Width : "w-full sm:w-[297px]"
      } maxInputWidth font-quicksand`}
    >
      {label && (
        <label htmlFor={inputId} className={labelClass}>
          {label}
          {required && !isAuth && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <div className={isAuth ? "relative" : undefined}>
        {isAuth && icon === "mail" && (
          <FiMail
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted"
            size={17}
            aria-hidden
          />
        )}
        <input
        id={inputId}
        type={Type ? Type : "text"}
        required={required}
        placeholder={placeholder}
        aria-label={label || placeholder}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={inputClass}
        value={Value}
        readOnly={readonly ? true : false}
        onChange={(e) => {
          const newValue = uppercaseAllowed
            ? e.target.value.toLowerCase()
            : e.target.value;
          setValue(newValue || "");
        }}
        onBlur={async (e) => {
          if (Named === "SaleBill") {
            const billNo = String(e.target.value ?? "").trim();
            if (!billNo) return;

            try {
              const result = await CheckInvoiceNoAvailabliltyAPI(billNo);

              if (result.data.success) {
                SuccessToast(result.data.data.msg);
              } else {
                WarningToast(
                  "Invoice already exists. Please use another number."
                );
                setValue("");
              }
            } catch (err) {
              ErrorToast(
                err.response.data.error.msg ||
                  "Something went wrong while checking invoice"
              );
              if (err.response.data.error.msg === "Invoice is not Available") {
                setValue("");
              }
            }
          }
        }}
        disabled={disabled ? disabled : false}
      />
      </div>
    </div>
  );
};

export default AuthInput;
